import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, theme } from '@chakra-ui/react';
import App from './App';
import './index.css';

interface LaunchParams {
  targetURL: string;
  files: never[];
}

interface LaunchQueue {
  setConsumer(callback: (params: LaunchParams) => void): void;
}

// Handle PWA installation and shortcuts
if ('launchQueue' in window) {
  
  const launchQueue = (window as unknown as { launchQueue: LaunchQueue }).launchQueue;
  launchQueue.setConsumer((launchParams: LaunchParams) => {
    
    // Get the target URL from launch params
    const url = new URL(launchParams.targetURL);
    const hash = url.hash.substring(1); // Remove the # from the hash

    // Handle different shortcuts
    switch (hash) {
      case 'scan':
        window.history.pushState(null, '', '/scan');
        window.dispatchEvent(new PopStateEvent('popstate'));
        break;
      case 'search':
        window.history.pushState(null, '', '/search');
        window.dispatchEvent(new PopStateEvent('popstate'));
        break;
      default:
    }
  });
}

// Handle PWA display mode
if (window.matchMedia('(display-mode: standalone)').matches) {
  
  // Focus existing window if one exists
  if ('clients' in navigator) {
    navigator.serviceWorker?.ready.then(() => {
      navigator.serviceWorker?.controller?.postMessage({
        type: 'FOCUS_EXISTING'
      });
    });
  }
}

// Cache assets for offline support
if ('caches' in window) {
  const CACHE_NAME = 'itemizer-v1';
  caches.open(CACHE_NAME).then(cache => {
    return cache.addAll([
      '/',
      '/index.html',
      '/manifest.json',
      '/favicon.ico'
    ]);
  });
}

/**
 * Entry point of the application
 * @function main
 * @description This is the entry point for the React application, rendering the App component inside a ChakraProvider.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
